import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { AUTH_TOKEN } from '@/constants';
import normalAuthRoutes from '@/modules/auth/normal/router';
import currentAuthRoutes from '@/modules/auth/current/router';
import adminRoutes from '@/modules/admin/router';
import NotAuthorized from '@/views/NotAuthorized.vue';
import Tracking from '@/views/TrackingView.vue';
import Simulation from '@/views/SimulationView.vue';
import Privacy from '@/views/PrivacyView.vue';
import { store } from '@/store'; // Ensure your store is properly imported
import i18n from '@/i18n';
// import getLoggedUser from '@/api/auth/getLoggedUser';
// import { LOGIN_USER } from '@/store/auth/constants';
// import { decryptToken } from '@/composables/encryptionUtil';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:lang',
    name: 'locale',
    redirect: (to) => {
      return `/${to.params.lang}/welcome`;
    },
    children: [
      // {
      //   path: '',
      //   redirect: (to) => {
      //     return {
      //       name: 'locale.root',
      //       params: to.params,
      //     };
      //   },
      // },

      {
        path: 'welcome',
        name: 'welcome',
        meta: {
          hide: true,
          title: 'Welcome Page',
        },
        component: () =>
          import(
            /* webpackChunkName: "welcome" */ '@/views/WelcomePageView.vue'
          ),
      },
      ...normalAuthRoutes,
      ...currentAuthRoutes,

      {
        path: 'not-authorized',
        name: 'not-authorized',
        component: NotAuthorized,
      },
      {
        path: 'tracking',
        name: 'tracking.global',
        component: Tracking,
      },
      {
        path: 'simulation',
        name: 'simulation',
        component: Simulation,
      },
      {
        path: 'apps/privacy',
        name: 'privacy',
        meta: {
          hide: true,
          title: 'Privacy Policy',
        },
        component: Privacy,
      },

      ...adminRoutes.map((route) => ({
        ...route,
        // meta: { requiresAuth: true },
      })),
    ],
  },
  // Catch-all route (must come last!)
  {
    path: '/:pathMatch(.*)*',
    redirect: (to) => {
      const lang = to.path.split('/')[1];
      const supportedLanguages = ['pt', 'en'];

      if (supportedLanguages.includes(lang)) {
        return { path: `/${lang}/welcome` };
      }

      return { path: '/pt/welcome' };
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const supportedLanguages = ['pt', 'en'];
  const lang = to.params.lang as string;

  // 1. No language in route? Redirect to default locale
  if (!lang) {
    const defaultLanguage = process.env.VUE_APP_DEFAULT_LOCALE || 'pt';
    return next({ name: 'locale', params: { lang: defaultLanguage } });
  }

  // 2. Language not supported? Redirect to default
  if (!supportedLanguages.includes(lang)) {
    return next({ path: '/pt/welcome' }); // Or use your default locale
  }

  // 3. Set current i18n language
  i18n.global.locale.value = lang;

  // 4. Set page title
  document.title =
    typeof to.meta?.title === 'string' ? to.meta.title : 'PORTAL DO CLIENTE';

  // 5. Auth check (unchanged from your setup)
  const token = window.localStorage.getItem(AUTH_TOKEN);
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      return next({ name: 'welcome', params: { lang } });
    }

    if (token) {
      try {
        return next();
      } catch (error) {
        const noInternet = window.navigator.onLine ? false : true;
        if (noInternet) {
          alert('No Internet Connection');
          return next(false);
        } else {
          return next({ name: 'welcome', params: { lang } });
        }
      }
    }

    return next({ name: 'welcome', params: { lang } });
  }

  // 6. Continue normally
  next();
});

export default router;
